<template>
  <div>
    <div class="literacy-content">
      <div class="literacy-head">
        <p class="literacy-number">2</p>
        <p class="cabin-family bold">What is your current financial position?</p>
      </div>

      <div class="literacy-body">
        <div class="form-group">
          <p class="cabin-family bold mb-0">My estimated annual income is</p>
          <div class="form-input-flex">
            <span>₦</span>
            <input type="number" v-model="userData.annual_income" class="form-control answer">
          </div>
        </div>

        <p class="cabin-family bold">My estimated financial net worth is:</p>
        <div class="form-group">
          <label>Primary Residence</label>
          <div class="form-input-flex">
            <span>₦</span>
            <input type="number" v-model="userData.residence" class="form-control answer">
          </div>
        </div>

        <div class="form-group">
          <label>Cash and Deposits</label>
          <div class="form-input-flex">
            <span>₦</span>
            <input type="number" v-model="userData.deposits" class="form-control answer">
          </div>
        </div>

        <div class="form-group">
          <label>Investment Products (Mutual Funds, Equities, Bonds, etc.)</label>
          <div class="form-input-flex">
            <span>₦</span>
            <input type="number" v-model="userData.investments" class="form-control answer">
          </div>
        </div>

        <div class="form-group">
          <label>Others (Real Estate, Business, etc.)</label>
          <div class="form-input-flex">
            <span>₦</span>
            <input type="number" v-model="userData.others" class="form-control answer">
          </div>
        </div>

        <div class="form-group">
        <label>Outstanding loans or credit</label>
        <div class="form-input-flex">
          <span>₦</span>
          <input type="number" v-model="userData.credit" class="form-control answer">
        </div>
        </div>

        <!-- <div class="form-group">
          <p class="bold">My Total Net Worth</p>
          <div class="form-input-flex">
            <span>₦</span>
            <input type="number" v-model="userData.total_worth" class="form-control answer">
          </div>
        </div> -->
      </div>

      <div class="literacy-footer text-center">
        <button class="btn primary-btn btn-block" :disabled="isDisabled" @click="next">Next</button>
        <p class="cabin-family bold mt-2" @click="previous">Previous</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    isDisabled() {
      if (!this.userData.annual_income) {
        return true;
      }
      return false;
    },
  },
  data() {
    return {
      userData: {
        annual_income: '',
        // total_worth: '',
        residence: '',
        deposits: '',
        investments: '',
        others: '',
        credit: '',
      },
    };
  },
  methods: {
    next() {
      this.$emit('next', this.userData);
    },
    previous() {
      this.$emit('previous');
    },
  },
  mounted() {
    window.scrollTo(0, 0);
  },
};
</script>

<style lang="scss" scoped>
  .answer{
    height: 35px;
    width: 80%;
  }
  label{
    font-weight: 400;
    margin-bottom: 0.25rem;
  }
  .form-input-flex{
    display: flex;
    align-items: center;
    background-color: #EDF2F9;
    color: #49566A;
    border: 1px solid #EDF2F9;
    border-radius: 8px;
    padding: 0 .5rem;
    width: 70%;
    span{
      font-size: 19px;
    }
  }
  .literacy-footer{
    position: relative;
    margin-top: 2rem;
    width: 100%;
  }
</style>
